/* Feather Footwear — "Added to cart" panel.
   After any Add to cart (product page or quick view):
   - the chosen size gets a green tick
   - a panel slides up: the pair just added, Checkout now, Continue shopping
   - "Pair it with": 3 other in-stock styles, same size pre-picked, showing
     the combined price and how much the customer saves vs the original price.
   Buy now (feather-buy.js) is left alone: it goes straight to checkout. */
(function () {
  'use strict';
  if (window.__ffAdded) return;
  window.__ffAdded = true;

  var INK = '#2B2320', IVORY = '#F6F0E6', SAND = '#EADFCC', TERRA = '#A9472A', GREEN = '#1F6B45';
  var SHOP_ALL = '/collections/all';

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rs(n) { return 'Rs ' + Math.round(n).toLocaleString('en-US'); }
  function short(t) { return String(t || '').replace(/^Women['’]s\s+/i, ''); }
  function img(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 240);
  }
  /* Product .js / recommendations give prices in paisa (cents); products.json gives "2399.00" */
  function money(v, cents) { if (v == null || v === '') return null; var n = parseFloat(v); if (isNaN(n)) return null; return cents ? n / 100 : n; }
  function norm(p, cents) {
    var vs = (p.variants || []).map(function (v) {
      var price = money(v.price, cents);
      var cmp = money(v.compare_at_price, cents);
      return { id: v.id, title: String(v.title), available: v.available !== false, price: price, compare: cmp && cmp > price ? cmp : price };
    });
    var first = vs.filter(function (v) { return v.available; })[0] || vs[0] || {};
    return {
      id: p.id, title: short(p.title), handle: p.handle, url: p.url || ('/products/' + p.handle),
      image: p.featured_image || (p.images && p.images[0]) || '',
      available: vs.some(function (v) { return v.available; }),
      variants: vs, price: first.price, compare: first.compare
    };
  }
  function getJSON(u) { return window.__ffFetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }

  /* ---------- styles ---------- */
  var css = [
    '.ff-size.is-added{position:relative;background:' + GREEN + '!important;color:#fff!important;border-color:' + GREEN + '!important}',
    '.ff-size.is-added::after{content:"✓";position:absolute;top:-7px;right:-7px;width:18px;height:18px;border-radius:50%;background:#fff;color:' + GREEN + ';font-size:11px;font-weight:800;line-height:18px;text-align:center;box-shadow:0 0 0 1.5px ' + GREEN + '}',
    '#ff-added{position:fixed;inset:0;z-index:2147483000;display:none;font-family:Manrope,system-ui,sans-serif;color:' + INK + '}',
    '#ff-added.is-open{display:block}',
    '#ff-added .ffa-bg{position:absolute;inset:0;background:rgba(43,35,32,.45);opacity:0;transition:opacity .25s}',
    '#ff-added.is-in .ffa-bg{opacity:1}',
    '#ff-added .ffa-panel{position:absolute;left:0;right:0;bottom:0;max-height:90vh;overflow-y:auto;-webkit-overflow-scrolling:touch;background:' + IVORY + ';border-radius:18px 18px 0 0;padding:14px 16px calc(18px + env(safe-area-inset-bottom));transform:translateY(100%);transition:transform .3s cubic-bezier(.2,.8,.2,1);box-shadow:0 -8px 30px rgba(0,0,0,.18)}',
    '#ff-added.is-in .ffa-panel{transform:none}',
    '#ff-added .ffa-grab{width:40px;height:4px;border-radius:2px;background:rgba(43,35,32,.2);margin:0 auto 10px}',
    '@media(min-width:768px){#ff-added .ffa-panel{left:auto;top:0;width:430px;max-height:none;border-radius:0;transform:translateX(100%);padding:22px 22px 28px}#ff-added .ffa-grab{display:none}}',
    '#ff-added .ffa-head{display:flex;align-items:center;gap:10px;margin-bottom:12px}',
    '#ff-added .ffa-ok{width:26px;height:26px;border-radius:50%;background:' + GREEN + ';color:#fff;display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:800;flex:none}',
    '#ff-added .ffa-head h2{font-family:Fraunces,Georgia,serif;font-size:20px;font-weight:600;margin:0;flex:1;letter-spacing:-.01em}',
    '#ff-added .ffa-x{width:36px;height:36px;border:0;background:transparent;font-size:26px;line-height:1;color:' + INK + ';cursor:pointer;border-radius:50%}',
    '#ff-added .ffa-item{display:flex;gap:12px;align-items:center;background:#fff;border-radius:12px;padding:10px;margin-bottom:12px}',
    '#ff-added .ffa-item img{width:68px;height:68px;object-fit:cover;border-radius:8px;background:' + SAND + ';flex:none}',
    '#ff-added .ffa-item b{display:block;font-size:15px;font-weight:700;line-height:1.25}',
    '#ff-added .ffa-meta{font-size:13px;margin-top:3px;color:rgba(43,35,32,.75)}',
    '#ff-added .ffa-pill{display:inline-block;background:' + GREEN + ';color:#fff;border-radius:999px;padding:1px 8px;font-size:12px;font-weight:700;margin-right:6px}',
    '#ff-added s{color:rgba(43,35,32,.5);font-weight:400}',
    '#ff-added .ffa-btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:52px;border-radius:12px;font:700 16px/1.2 Manrope,system-ui,sans-serif;text-decoration:none;cursor:pointer;border:0;padding:0 14px;margin:0 0 8px}',
    '#ff-added .ffa-go{background:' + INK + '!important;color:' + IVORY + '!important}',
    '#ff-added .ffa-more{background:transparent!important;color:' + INK + '!important;border:1.5px solid ' + INK + '!important}',
    '#ff-added .ffa-cart{display:block;text-align:center;font-size:13px;color:' + INK + ';text-decoration:underline;margin:2px 0 4px}',
    '#ff-added .ffa-cod{text-align:center;font-size:12px;color:rgba(43,35,32,.7);margin:6px 0 0}',
    '#ff-added .ffa-pairs{margin-top:18px;border-top:1px solid rgba(43,35,32,.12);padding-top:16px}',
    '#ff-added .ffa-pairs h3{font-family:Fraunces,Georgia,serif;font-size:18px;font-weight:600;margin:0 0 2px}',
    '#ff-added .ffa-pairs p.ffa-sub{font-size:13px;margin:0 0 12px;color:rgba(43,35,32,.7)}',
    '#ff-added .ffa-card{background:#fff;border-radius:14px;padding:12px;margin-bottom:12px}',
    '#ff-added .ffa-duo{display:flex;align-items:center;gap:8px}',
    '#ff-added .ffa-duo figure{margin:0;flex:1;text-align:center}',
    '#ff-added .ffa-duo img{display:block;margin:0 auto;width:104px;height:104px;object-fit:cover;border-radius:10px;background:' + SAND + '}',
    '#ff-added .ffa-duo figcaption{font-size:11px;margin-top:4px;color:rgba(43,35,32,.7);line-height:1.25}',
    '#ff-added .ffa-plus{font-size:22px;font-weight:300;flex:none}',
    '#ff-added .ffa-name{font-weight:700;font-size:14px;margin:10px 0 6px}',
    '#ff-added .ffa-name a{color:inherit;text-decoration:none}',
    '#ff-added .ffa-sizes{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px}',
    '#ff-added .ffa-sizes button{min-width:40px;height:36px;border-radius:8px;border:1.5px solid rgba(43,35,32,.25);background:#fff;color:' + INK + ';font:600 14px Manrope,system-ui,sans-serif;cursor:pointer;padding:0 6px}',
    '#ff-added .ffa-sizes button.is-on{background:' + INK + ';color:' + IVORY + ';border-color:' + INK + '}',
    '#ff-added .ffa-sizes button:disabled{opacity:.35;text-decoration:line-through;cursor:default}',
    '#ff-added .ffa-total{display:flex;justify-content:space-between;align-items:baseline;gap:8px;flex-wrap:wrap;font-size:14px;margin-bottom:4px}',
    '#ff-added .ffa-total b{font-size:17px}',
    '#ff-added .ffa-save{display:inline-block;background:#F3E1D8;color:' + TERRA + ';font-weight:800;font-size:13px;border-radius:6px;padding:3px 8px;margin-bottom:10px}',
    '#ff-added .ffa-addpair{background:' + TERRA + '!important;color:#fff!important;min-height:46px;font-size:15px;margin:0}',
    '#ff-added .ffa-addpair:disabled{opacity:.55;cursor:default}',
    '#ff-added .ffa-addpair.is-done{background:' + GREEN + '!important}',
    '#ff-added .ffa-loading{font-size:13px;color:rgba(43,35,32,.6);padding:6px 0}',
    '#ff-added button:focus-visible,#ff-added a:focus-visible{outline:2px solid ' + TERRA + ';outline-offset:2px}',
    '#ff-added *{-webkit-tap-highlight-color:transparent}'
  ].join('\n');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* ---------- panel markup ---------- */
  var root = document.createElement('div');
  root.id = 'ff-added';
  root.setAttribute('role', 'dialog');
  root.setAttribute('aria-modal', 'true');
  root.setAttribute('aria-labelledby', 'ffa-title');
  root.setAttribute('aria-hidden', 'true');
  root.innerHTML =
    '<div class="ffa-bg" data-ffa-close></div>' +
    '<div class="ffa-panel">' +
      '<div class="ffa-grab"></div>' +
      '<div class="ffa-head"><span class="ffa-ok" aria-hidden="true">✓</span><h2 id="ffa-title">Added to cart</h2>' +
        '<button type="button" class="ffa-x" data-ffa-close aria-label="Close">×</button></div>' +
      '<div class="ffa-item" data-ffa-item></div>' +
      '<a class="ffa-btn ffa-go" href="/checkout" data-ffa-go>Checkout now</a>' +
      '<a class="ffa-btn ffa-more" href="' + SHOP_ALL + '" data-ffa-more>Continue shopping</a>' +
      '<a class="ffa-cart" href="/cart">View cart</a>' +
      '<p class="ffa-cod">Cash on Delivery all over Pakistan · 7-day exchange</p>' +
      '<div class="ffa-pairs" data-ffa-pairs hidden>' +
        '<h3>Pair it with another</h3>' +
        '<p class="ffa-sub">Your pair + one more, in your size. See how much you save.</p>' +
        '<div data-ffa-list><div class="ffa-loading">Finding styles in your size…</div></div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(root);

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
    setTimeout(function () { var f = $('[data-ffa-go]', root); if (f) f.focus({ preventScroll: true }); }, 320);
  }
  function close() {
    root.classList.remove('is-in'); root.setAttribute('aria-hidden', 'true');
    setTimeout(function () { root.classList.remove('is-open'); document.documentElement.style.overflow = ''; }, 280);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  $$('[data-ffa-close]', root).forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  window.addEventListener('pageshow', function () { if (root.classList.contains('is-open')) { root.classList.remove('is-open', 'is-in'); document.documentElement.style.overflow = ''; } });

  /* ---------- checkout button shows the live cart total ---------- */
  function refreshTotal() {
    return getJSON('/cart.js').then(function (c) {
      var go = $('[data-ffa-go]', root);
      var n = c.item_count;
      go.textContent = 'Checkout now · ' + n + (n === 1 ? ' pair' : ' pairs') + ' · ' + rs(c.total_price / 100);
      $$('[data-ff-count]').forEach(function (b) { b.textContent = n; b.hidden = n < 1; });
    }).catch(function () {});
  }

  /* ---------- "Pair it with" ---------- */
  var current = null; /* {product, variant} */
  function pairCard(o) {
    var cur = current.product, cv = current.variant;
    var same = o.variants.filter(function (v) { return v.title === cv.title && v.available; })[0];
    var card = document.createElement('div');
    card.className = 'ffa-card';
    card.innerHTML =
      '<div class="ffa-duo">' +
        '<figure><img src="' + esc(img(cur.image, 300)) + '" alt="" loading="lazy" width="150" height="150"><figcaption>Your pair</figcaption></figure>' +
        '<span class="ffa-plus" aria-hidden="true">+</span>' +
        '<figure><a href="' + esc(o.url) + '"><img src="' + esc(img(o.image, 300)) + '" alt="' + esc(o.title) + '" loading="lazy" width="150" height="150"></a><figcaption>Add this pair</figcaption></figure>' +
      '</div>' +
      '<div class="ffa-name"><a href="' + esc(o.url) + '">' + esc(o.title) + '</a></div>' +
      '<div class="ffa-sizes" role="group" aria-label="Size for ' + esc(o.title) + '"></div>' +
      '<div class="ffa-total"><span>Both for <b data-t></b> <s data-c></s></span></div>' +
      '<div class="ffa-save" data-s></div>' +
      '<button type="button" class="ffa-btn ffa-addpair" data-add></button>';
    var sizes = $('.ffa-sizes', card), addB = $('[data-add]', card);
    var pick = null;
    function paint() {
      var v = pick || same || o.variants.filter(function (x) { return x.available; })[0];
      var total = cv.price + v.price;
      var was = cv.compare + v.compare;
      $('[data-t]', card).textContent = rs(total);
      $('[data-c]', card).textContent = was > total ? rs(was) : '';
      $('[data-s]', card).textContent = was > total ? 'You save ' + rs(was - total) + ' on both pairs' : '';
      $('[data-s]', card).hidden = !(was > total);
      if (addB.classList.contains('is-done')) return;
      addB.disabled = !pick;
      addB.textContent = pick ? 'Add size ' + pick.title + ' · ' + rs(pick.price) : 'Choose a size';
    }
    o.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = v.title;
      b.setAttribute('aria-pressed', 'false');
      if (!v.available) { b.disabled = true; b.setAttribute('aria-label', 'Size ' + v.title + ', sold out'); }
      b.addEventListener('click', function () {
        $$('button', sizes).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        pick = v;
        if (addB.classList.contains('is-done')) { addB.classList.remove('is-done'); }
        paint();
      });
      sizes.appendChild(b);
      if (same && v.id === same.id) { b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); pick = v; }
    });
    addB.addEventListener('click', function () {
      if (!pick || addB.classList.contains('is-done')) return;
      addB.disabled = true; addB.textContent = 'Adding…';
      window.__ffFetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: pick.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add this size'); });
        addB.classList.add('is-done'); addB.disabled = false;
        addB.textContent = '✓ Added — size ' + pick.title;
        return refreshTotal();
      }).catch(function (err) {
        addB.disabled = false; addB.textContent = err.message || 'Try again';
        setTimeout(paint, 2500);
      });
    });
    paint();
    return card;
  }

  function loadPairs() {
    var box = $('[data-ffa-pairs]', root), list = $('[data-ffa-list]', root);
    box.hidden = false;
    list.innerHTML = '<div class="ffa-loading">Finding styles in your size…</div>';
    var me = current;
    var want = current.variant.title;
    var seen = {}; seen[current.product.id] = 1;
    var picks = [];
    function take(arr) {
      arr.forEach(function (p) {
        if (seen[p.id] || !p.available || p.price == null) return;
        seen[p.id] = 1; picks.push(p);
      });
    }
    getJSON('/recommendations/products.json?product_id=' + current.product.id + '&limit=10&intent=related')
      .then(function (d) { take((d.products || []).map(function (p) { return norm(p, true); })); })
      .catch(function () {})
      .then(function () {
        if (picks.length >= 6) return;
        return getJSON(SHOP_ALL + '/products.json?limit=60').then(function (d) {
          take((d.products || []).map(function (p) { return norm(p, false); }));
        }).catch(function () {});
      })
      .then(function () {
        if (me !== current) return;
        /* Styles with the customer's size in stock come first */
        picks.sort(function (a, b) {
          var ha = a.variants.some(function (v) { return v.title === want && v.available; }) ? 0 : 1;
          var hb = b.variants.some(function (v) { return v.title === want && v.available; }) ? 0 : 1;
          return ha - hb;
        });
        var three = picks.slice(0, 3);
        if (!three.length) { box.hidden = true; return; }
        list.innerHTML = '';
        three.forEach(function (o) { list.appendChild(pairCard(o)); });
      });
  }

  function show(item) {
    /* item = line item returned by /cart/add.js */
    var handle = item.handle || (item.url || '').split('/products/')[1];
    handle = String(handle || '').split('?')[0];
    $('[data-ffa-item]', root).innerHTML =
      '<img src="' + esc(img(item.image || item.featured_image && item.featured_image.url, 200)) + '" alt="" width="68" height="68">' +
      '<div><b>' + esc(short(item.product_title || item.title)) + '</b>' +
      '<div class="ffa-meta"><span class="ffa-pill">Size ' + esc(item.variant_title || '') + ' ✓</span>' +
      rs((item.final_price != null ? item.final_price : item.price) / 100) + ' <s data-ffa-was></s></div></div>';
    $('[data-ffa-pairs]', root).hidden = true;
    $('[data-ffa-go]', root).textContent = 'Checkout now';
    open();
    refreshTotal();
    if (!handle) return;
    getJSON('/products/' + handle + '.js').then(function (p) {
      var prod = norm(p, true);
      var v = prod.variants.filter(function (x) { return String(x.id) === String(item.variant_id || item.id); })[0];
      if (!v) return;
      prod.image = prod.image || item.image;
      current = { product: prod, variant: v };
      var was = $('[data-ffa-was]', root);
      if (was && v.compare > v.price) was.textContent = rs(v.compare);
      loadPairs();
    }).catch(function () {});
  }

  /* ---------- tick on the size pill + tidy the old buttons ---------- */
  function markSize(item) {
    var pdp = $('[data-ff-pdp]');
    if (pdp) {
      $$('.ff-size', pdp).forEach(function (b) {
        if (b.classList.contains('is-on') && b.textContent.trim() === String(item.variant_title)) b.classList.add('is-added');
      });
    }
    var qv = $('#ff-qv');
    if (qv && qv.classList.contains('is-open')) {
      qv.classList.remove('is-open'); qv.setAttribute('aria-hidden', 'true');
      var cta = $('[data-qv-add]', qv);
      if (cta) setTimeout(function () { cta.dataset.added = ''; }, 50);
    }
  }
  /* On the product page, picking another size after an add should add that size again,
     not jump to the cart (the old button kept its "go to cart" click). */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-ff-pdp] .ff-size');
    if (!s) return;
    var pdp = $('[data-ff-pdp]');
    var a = pdp && $('[data-pdp-add]', pdp);
    var sticky = $('[data-ff-sticky] button');
    [a, sticky].forEach(function (b) { if (b) b.onclick = null; });
  }, true);

  /* ---------- listen for every add to cart on the page ---------- */
  var orig = window.fetch.bind(window);
  window.__ffFetch = orig;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = orig(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && String(init.method || '').toUpperCase() === 'POST') {
      p.then(function (r) {
        if (!r.ok) return;
        /* Buy now goes straight to checkout — no panel */
        if ($('.ff-buy[disabled]')) return;
        r.clone().json().then(function (d) {
          var item = (d.items && d.items[0]) || d;
          if (!item || !item.variant_id && !item.id) return;
          markSize(item);
          show(item);
        }).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };
})();
